import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getTestId, IconButton, Input, isValidObject } from '@airtel/air-design-system';
import { useRef, useState } from 'react';
import { Animated, View } from 'react-native';
import { withBoundaries } from '../../hoc';
import { QuickFilterWidget } from '../quick-filter-widget';
import { getSearchAndFilterWidgetStyles } from './SearchAndFilterWidgetStyles';
var SearchAndFilterWidgetComponent = props => {
  var _a;
  var id = props.id,
    inputProps = props.inputProps,
    iconButtonProps = props.iconButtonProps,
    quickFilterProps = props.quickFilterProps,
    showFilterUpfrontAB = props.showFilterUpfrontAB,
    _props$showFilter = props.showFilter,
    showFilter = _props$showFilter === void 0 ? true : _props$showFilter,
    filterStyle = props.filterStyle,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'SearchAndFilterWidget' : _props$testID,
    style = props.style;
  var _useState = useState(quickFilterProps === null || quickFilterProps === void 0 ? void 0 : quickFilterProps.list),
    filterList = _useState[0],
    setFilterList = _useState[1];
  var showFilterUpfront = showFilterUpfrontAB && ((_a = quickFilterProps === null || quickFilterProps === void 0 ? void 0 : quickFilterProps.list) === null || _a === void 0 ? void 0 : _a.length) > 0;
  var _useState2 = useState(showFilterUpfront ? 'SearchIcon' : 'FilterIcon'),
    icon = _useState2[0],
    setIcon = _useState2[1];
  var _useState3 = useState('none'),
    iconControlState = _useState3[0],
    setIconControlState = _useState3[1];
  var _useState4 = useState('secondary'),
    iconType = _useState4[0],
    setIconType = _useState4[1];
  var _useState5 = useState(iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.searchFilterIconProps),
    iconColorProps = _useState5[0],
    setIconColorProps = _useState5[1];
  var animation = useRef(new Animated.Value(0)).current;
  var searchAndFilterWidgetStyles = getSearchAndFilterWidgetStyles(animation, showFilterUpfront, icon);
  var startAnimation = () => {
    animation.setValue(showFilterUpfront ? 1 : 0);
    Animated.timing(animation, {
      toValue: showFilterUpfront ? 0 : 1,
      duration: showFilterUpfront ? 500 : 300,
      useNativeDriver: false
    }).start(() => {
      setIconProps('SearchIcon', 'none', 'secondary', iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.searchFilterIconProps);
    });
  };
  var onReadOnlyPressCallback = () => {
    (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onInputPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onInputPressMetaData), Object.assign({}, props)));
  };
  var onFilterItemPressCallback = (actions, extraData) => {
    var _a;
    if ((_a = extraData === null || extraData === void 0 ? void 0 : extraData.filterList) === null || _a === void 0 ? void 0 : _a.length) {
      setIconProps('CancelIcon', 'selected', 'primary', iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.cancelIconProps);
    } else {
      setIconProps('SearchIcon', 'none', 'secondary', iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.searchFilterIconProps);
    }
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(actions, extraData);
  };
  var onEndAnimationCallback = () => {
    if (icon == 'CancelIcon') {
      setFilterList([...filterList]);
      (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onCrossIconPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onCrossIconPressMetaData), Object.assign({}, props)));
    }
  };
  var endAnimation = () => {
    setIconProps('FilterIcon', 'none', 'secondary', iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.searchFilterIconProps);
    animation.setValue(showFilterUpfront ? 0 : 1);
    Animated.timing(animation, {
      toValue: showFilterUpfront ? 1 : 0,
      duration: showFilterUpfront ? 300 : 500,
      useNativeDriver: false
    }).start(onEndAnimationCallback);
  };
  var onItemPress = () => {
    if (icon == 'FilterIcon') {
      startAnimation();
      (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onFilterIconPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onFilterIconPressMetaData), Object.assign({}, props)));
    }
    if (icon === 'CancelIcon') {
      if (!showFilterUpfront) {
        endAnimation();
        (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onCancelIconPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onCancelIconPressMetaData), Object.assign({}, props)));
      } else {
        setFilterList([...filterList]);
        setIconProps('SearchIcon', 'none', 'secondary', iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.searchFilterIconProps);
      }
    }
    if (icon === 'SearchIcon') {
      if (!showFilterUpfront) {
        endAnimation();
      }
      (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onSearchIconPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onSearchIconPressMetaData), Object.assign({}, props)));
    }
  };
  var setIconProps = (iconName, iconControlState, iconType, iconColorProps) => {
    setIcon(iconName);
    setIconControlState(iconControlState);
    setIconType(iconType);
    setIconColorProps(iconColorProps);
  };
  if (!isValidObject(inputProps)) return null;
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [searchAndFilterWidgetStyles.container, style]
  }, {
    children: [_jsx(Animated.View, Object.assign({
      style: searchAndFilterWidgetStyles.inputStyle
    }, {
      children: _jsx(Input, Object.assign({
        size: "md"
      }, inputProps, {
        readOnlyOnPress: onReadOnlyPressCallback,
        textInputOverrides: Object.assign(Object.assign({}, inputProps === null || inputProps === void 0 ? void 0 : inputProps.textInputOverridesProps), {
          onPressIn: () => {
            onReadOnlyPressCallback();
          }
        })
      }, getTestId(testID, 'input')))
    })), showFilter && _jsxs(_Fragment, {
      children: [_jsx(IconButton, Object.assign({
        size: "sm"
      }, iconButtonProps, {
        iconName: icon,
        controlState: iconControlState,
        type: iconType,
        iconProps: iconColorProps,
        onPress: () => {
          onItemPress();
        }
      }, getTestId(testID, 'icon_button'), {
        style: searchAndFilterWidgetStyles.iconButtonStyle
      })), _jsx(Animated.View, Object.assign({
        style: [searchAndFilterWidgetStyles.filterStyle, filterStyle]
      }, {
        children: _jsx(QuickFilterWidget, Object.assign({}, quickFilterProps, {
          onUserAction: onFilterItemPressCallback
        }, getTestId(testID, 'filter'), {
          list: filterList
        }))
      }))]
    })]
  }));
};
SearchAndFilterWidgetComponent.genericRendererKey = 'AirSearchAndFilterWidget';
export var SearchAndFilterWidget = withBoundaries(SearchAndFilterWidgetComponent);